// C4 — inline `?` glossary affordance (UX rule #9: "plain words, with
// help on tap"). Wrap any Cleanup term:
//
//   <GlossaryTerm k="survivor">Survivor</GlossaryTerm>
//
// Renders the term followed by a small `?` whose native title +
// aria-label carry the plain-language definition. Native title is
// deliberate: it works inside the in-record Drawer with zero
// popover-positioning risk and is screen-reader accessible. Unknown
// keys degrade to plain text (no `?`), so a typo never shows an empty
// bubble.

import { lookupGlossary } from "./cleanup-glossary";

export function GlossaryTerm({
  k,
  children,
}: {
  k: string;
  children: React.ReactNode;
}) {
  const entry = lookupGlossary(k);
  if (!entry) return <>{children}</>;
  return (
    <span style={{ whiteSpace: "nowrap" }}>
      {children}
      <span
        role="note"
        tabIndex={0}
        aria-label={`${entry.term}: ${entry.definition}`}
        title={entry.definition}
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 14,
          height: 14,
          marginLeft: 3,
          borderRadius: 9999,
          border: "1px solid var(--blue)",
          color: "var(--blue)",
          fontSize: 9.5,
          fontWeight: 800,
          lineHeight: 1,
          cursor: "help",
          verticalAlign: "super",
        }}
      >
        ?
      </span>
    </span>
  );
}
